/* Kalemsy: sepet çekmecesindeki tepsi eki ve uç/silgi kutusu (kls-sepet-uc; çekmece ve /cart). Çekmece yeniden çizildiğinde de çalışsın diye belge düzeyinde dinler. */
(() => {
  if (window.kalemsySepetEk) return;
  window.kalemsySepetEk = true;

  document.addEventListener('click', async (e) => {
    const dugme = e.target.closest('[data-kse-ekle]');
    if (!dugme || dugme.classList.contains('is-loading')) return;
    const cekmece = dugme.closest('cart-drawer');
    const hata = dugme.closest('.kse') && dugme.closest('.kse').querySelector('.kse__hata');
    const bolumler = ['cart-icon-bubble'];
    if (cekmece && cekmece.closest('.shopify-section')) {
      bolumler.push(cekmece.closest('.shopify-section').id.replace('shopify-section-', ''));
    }
    dugme.classList.add('is-loading');
    if (hata) hata.hidden = true;

    try {
      const yanit = await fetch(`${theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(dugme.dataset.kseEkle), quantity: 1 }],
          sections: bolumler.join(','),
          sections_url: window.location.pathname
        })
      });
      const veri = await yanit.json();
      if (!yanit.ok) throw new Error(veri.description || veri.message || 'Sepete eklenemedi.');
      const balon = document.getElementById('cart-icon-bubble');
      if (balon && veri.sections && veri.sections['cart-icon-bubble']) balon.innerHTML = veri.sections['cart-icon-bubble'];
      if (cekmece) {
        await cekmece.renderContents(veri, false);
        document.dispatchEvent(new CustomEvent('on:css-var-height:update'));
      } else if (dugme.closest('[data-kls-ucs-yer]')) {
        // Kalemsy 6 Ekim 2026: /cart sayfasındaki uç ve silgi kutusu. Satırlar, toplam ve kutu birlikte doğru olsun diye sayfa yenilenir.
        window.location.reload();
      }
    } catch (err) {
      dugme.classList.remove('is-loading');
      if (hata) {
        hata.textContent = err.message;
        hata.hidden = false;
      }
    }
  });

  // Kalemsy 6 Ekim 2026: /cart sayfasında adet değişince (cart-items on:line-item:change) uç ve silgi kutusu tazelenir.
  // Çekmecedeki kutu #cart-promoted-products ile zaten yeniden çiziliyor; burada yalnız sayfadaki yer ele alınır.
  document.addEventListener('on:line-item:change', async () => {
    const yerler = Array.from(document.querySelectorAll('[data-kls-ucs-yer]')).filter((el) => !el.closest('cart-drawer'));
    if (!yerler.length) return;
    try {
      const yanit = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(yerler[0].dataset.klsUcsYer)}`);
      if (!yanit.ok) return;
      const tmpl = document.createElement('template');
      tmpl.innerHTML = await yanit.text();
      const yeni = tmpl.content.querySelector('[data-kls-ucs-yer]');
      yerler.forEach((el) => { el.innerHTML = yeni ? yeni.innerHTML : ''; });
    } catch (err) {
      // Kutu bayat kalırsa sayfa yenilemesi düzeltir; sepet işlemini engelleme.
    }
  });
})();
